var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8098 13.7944L19.0759 16.0222C18.9255 16.3163 18.7573 16.6051 18.5713 16.8873C18.3852 17.1695 18.186 17.4378 17.9749 17.6919L15.4846 17.4142C14.8184 17.9608 14.0495 18.3869 13.2113 18.6592L12.0471 20.945C11.7188 20.9813 11.3851 21 11.0471 21C10.7091 21 10.3754 20.9813 10.0471 20.945L8.8798 18.6582C8.04116 18.3854 7.27202 17.9585 6.60578 17.4111L4.10095 17.6915C3.88991 17.4374 3.69068 17.1691 3.50462 16.8869C3.31855 16.6047 3.15044 16.3159 3 16.0218L4.27324 13.7814C4.1249 13.2142 4.04708 12.6139 4.04708 12.0002C4.04708 11.3749 4.12906 10.7688 4.28287 10.192L3.00038 7.936C3.15082 7.64191 3.31893 7.3531 3.505 7.07091C3.69106 6.78873 3.89029 6.52043 4.10133 6.2663L6.6563 6.55327C7.31463 6.02075 8.06312 5.60683 8.88687 5.33984M8.88302 5.33996L10.0468 3.05493C10.3752 3.01863 10.7088 3 11.0468 3C11.3849 3 11.7185 3.01863 12.0468 3.05493L13.2107 5.33996C14.0351 5.60716 14.7857 6.01764 15.4444 6.55077L17.9743 6.26661C18.1854 6.52074 18.3846 6.78904 18.5707 7.07123C18.7567 7.35341 18.9248 7.64223 19.0753 7.93632L17.8061 10.1697M17.8063 10.1732C17.9633 10.7556 18.0471 11.3681 18.0471 12.0002C18.0471 12.6215 17.9661 13.2239 17.8142 13.7974M14.0471 12.0002C14.0471 13.657 12.7039 15.0002 11.0471 15.0002C9.39022 15.0002 8.04707 13.657 8.04707 12.0002C8.04707 10.3433 9.39022 9.00015 11.0471 9.00015C12.7039 9.00015 14.0471 10.3433 14.0471 12.0002Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemwhite);
export default __webpack_public_path__ + "static/media/memwhite.debcdcd4c14eebfce9e67629a90c3aaa.svg";
export { ForwardRef as ReactComponent };